/* eslint-disable no-unused-vars */
export enum FileType {
  IMAGE = 'image/*',
  DOC = '.doc',
  TXT = '.txt',
  CSV = '.csv',
  JPG = '.jpg',
  PNG = '.png',
  GIF = '.gif',
  MP4 = '.mp4',
  AVI = '.avi',
  MOV = '.mov',
  MKV = '.mkv',
  JSON = '.json',
  PDF = '.pdf',
}